import React from "react";

import BasicButton from "components/General/BasicButton";


export interface OpenInterface {
  open?: boolean,
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>,
}

export interface ModalInterface {
  children: React.ReactNode
  open?: boolean,
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>,
}

export default function ModalWrapper({
  children,
  open,
  setOpen,
} : ModalInterface) {
  return (
    <div
      className={`transition duration-100 absolute left-0 top-0 h-full w-full
        z-[9999]
        flex flex-col items-center justify-center
        ${open
          ? `pointer-events-auto opacity-1` 
        
          : `pointer-events-none opacity-0`}
      `}
    >
      <div className="absolute left-0 top-0 h-full w-full bg-black bg-opacity-30" onClick={() => setOpen?.(false)}/>
      <div className={`
        relative border-black
        min-w-[30%] min-h-[30%]

        h-full
        lg:h-auto
        sm:max-w-[80%] sm:max-h-[80%]
        border-0 sm:border-2 
        bg-[#BCB7A8]
      `}>
        <div className="w-full h-full overflow-y-auto p-4">
          { children }
        </div>
        <div className="absolute right-0 top-0 m-2">
          <BasicButton onClick={() => setOpen?.(false)} text={"x"}/>
        </div>
      </div>
    </div>
  )
}
